<template>
  <div class="w-full max-w-[263px] m-auto" :class="rootClass">
    <!-- Etiquetas y marcas -->
    <div class="relative select-none">
      <div class="flex justify-between text-[11px] leading-none mb-1">
        <span
          v-for="(t, i) in ticks"
          :key="'label-' + i"
          :class="[
            'tabular-nums',
            strongSet.has(t) ? 'text-zinc-900 dark:text-zinc-100 font-medium' : 'text-zinc-400 dark:text-zinc-500'
          ]"
        >
          {{ labelFormatter(t) }}
        </span>
      </div>
      <div v-if="showTicks" class="relative h-3" style="margin: 0 10px">
        <span
          v-for="(t, i) in ticks"
          :key="'tick-' + i"
          class="absolute bottom-0 inline-block w-px"
          :style="{ left: pct(t) + '%', transform: 'translateX(-50%)', height: '8px', backgroundColor: 'rgb(24 24 27 / 0.7)' }"
        ></span>
      </div>
    </div>

    <!-- Pista y relleno -->
    <div class="relative">
      <div class="rounded-full bg-zinc-100 dark:bg-zinc-800 shadow-inner p-[6px]">
        <div
          class="h-5 rounded-full transition-all duration-300"
          :class="fillClass"
          :style="{ width: percent + '%', backgroundColor: getColorByScore(value)}"
        ></div>
      </div>
    </div>
  </div>
</template>


<script>
import MixinIAReputation from "@/mixins/iareputation.js"

export default {
  name: 'ScaleBar',
  mixins: [MixinIAReputation],
  props: {
    // valor único entre -1 y 1
    value: { type: Number, required: true },
    min: { type: Number, default: -1 },
    max: { type: Number, default: 1 },
    ticks: {
      type: Array,
      default: () => [-1, -0.5, 0, 0.5, 1]
    },
    rootClass: { type: String, default: '' },
    fillClass: { type: String, default: 'bg-emerald-500' },
    labelStrongValues: {
      type: Array,
      default: () => [-1, 0, 1]
    },
    showTicks: { type: Boolean, default: true },
    labelFormatter: {
      type: Function,
      default: v => (Number.isInteger(v) ? String(v) : v.toFixed(2))
    }
  },
  computed: {
    range () { return this.max - this.min },
    vClamped () {
      return Math.min(this.max, Math.max(this.min, this.value))
    },
    percent () {
      // relleno desde min hasta el valor
      return ((this.vClamped - this.min) / this.range) * 100
    },
    strongSet () { return new Set(this.labelStrongValues) }
  },
  methods: {
    pct (v) { return ((v - this.min) / this.range) * 100 }
  }
}
</script>

<style scoped>
.max-w-\[263px\]{
max-width: 263px;
}
.p-\[6px\]{
padding:6px;
}
.shadow-inner { box-shadow: inset 0 1px 2px rgba(0,0,0,.06); }
/* --- Layout / display --- */
.w-full{width:100%;}
.relative{position:relative;}
.absolute{position:absolute;}
.inline-block{display:inline-block;}
.flex{display:flex;}
.justify-between{justify-content:space-between;}
.bottom-0{bottom:0;}
.w-px{width:1px;}

/* --- Spacing / size / shape --- */
.mb-1{margin-bottom:0.25rem;}   /* 4px */
.mb-2{margin-bottom:0.5rem;}    /* 8px */
.p-1{padding:0.25rem;}          /* 4px */
.h-3{height:0.75rem;}           /* 12px */
.h-5{height:1.25rem;}           /* 20px */
.rounded-full{border-radius:9999px;}

/* --- Typography --- */
.text-\[11px\]{font-size:11px;}
.leading-none{line-height:1;}
.tabular-nums{font-variant-numeric:tabular-nums;font-feature-settings:"tnum" 1;}
.select-none{user-select:none;}


.bg-zinc-100{background-color:#f4f4f5;}


/* --- Transiciones / sombras --- */
.transition-all{
  transition-property:all;
  transition-timing-function:cubic-bezier(0.4,0,0.2,1);
}

</style>
